module.exports = __webpack_public_path__ + "img/habitat.c170aca6.png";